import { apiService } from '../../shared/services/apiService';
import {
  SelfBillingSetupCardConfig,
  SelfBillingPaymentIntent,
  SelfBillingPaymentRetryResult,
} from '../interfaces/selfBillingStripe';
import { EntityPaymentMethodDetails } from '../../shared/interfaces/entityPaymentMethodDetails';
import { PaymentInfo } from '../interfaces/paymentResult';
import { SelfBillingNextPaymentInfo } from '../interfaces/selfBillingNextPaymentInfo';

type GetStripeConnectLinkResponse = { stripeUrl: string };

type GetPublishApiKeyResponse = {
  key: string;
  connectedAccountId: string; // not exist for super admin
};

type GetConnectedAccountIdResponse = {
  stripeAccountID: string;
};

type GetStripePublicKeyResponse = {
  key: string;
};

export const stripeService = {
  // used on create NEW flow entity page
  //   async getStripeConnectLinkBySuper(entityId: number, redirectPageUrl: string) {
  //     const params = { entityID: entityId, redirectSubUrl: redirectPageUrl };

  //     const resp = await apiService.get<GetStripeConnectLinkResponse>(
  //       'api/super/get-stripe-link',
  //       { params },
  //     );

  //     return resp.data;
  //   },

  async getStripeConnectLinkByEntity(entityId: number) {
    const resp = await apiService.get<GetStripeConnectLinkResponse>(
      `/api/entity/${entityId}/stripe/connect-account-link`,
    );

    return resp.data;
  },

  async getPublishApiKey() {
    const resp = await apiService.get<GetPublishApiKeyResponse>('api/publish-api-key');

    return resp.data;
  },

  async getConnectedAccountId(entityId: number) {
    const resp = await apiService.get<GetConnectedAccountIdResponse>(
      `/api/super/entity/${entityId}/stripe-account-id`,
    );

    return resp.data;
  },

  async getStripePublicKey() {
    const resp = await apiService.get<GetStripePublicKeyResponse>('api/payment/pubkey');

    return resp.data;
  },

  async updateCustomerCard(customerId: number, paymentMethodId: string) {
    const params = { paymentMethodId };

    const resp = await apiService.put<undefined>(
      `api/coach/card-details/${customerId}`,
      undefined,
      { params },
    );

    return resp.data;
  },

  async updateEntityCard(entityId: number, paymentMethodId: string) {
    const params = { paymentMethodId };

    const resp = await apiService.put<EntityPaymentMethodDetails>(
      `/api/admin/entity/${entityId}/payment/card-details`,
      undefined,
      { params },
    );

    return resp.data;
  },

  async getSelfBillingSetupInitialCardConfig(entityId: number) {
    const resp = await apiService.get<SelfBillingSetupCardConfig>(
      `/api/entity/${entityId}/payment/card-setup`,
    );

    return resp.data;
  },

  async getSelfBillingPaymentIntent(
    entityId: number,
    config: { ignoreErrorCodes?: number[] } = {},
  ) {
    const resp = await apiService.get<SelfBillingPaymentIntent>(
      `/api/entity/${entityId}/payment/payment-intent`,
      config,
    );

    return resp.data;
  },

  async selfBillingPaymentRetry(entityId: number) {
    const resp = await apiService.post<SelfBillingPaymentRetryResult>(
      `/api/entity/${entityId}/payment/retry`,
    );

    return resp.data;
  },

  async getSelfBillingPaymentResult(entityId: number, paymentIntentId: string) {
    const params = { paymentIntentId };

    const resp = await apiService.post<PaymentInfo>(
      `/api/admin/entity/${entityId}/payment/result`,
      undefined,
      { params },
    );

    return resp.data;
  },

  async getSelfBillingNextPaymentInfo(entityId: number) {
    const resp = await apiService.get<SelfBillingNextPaymentInfo>(
      `/api/entity/${entityId}/payment/entity-plan`,
    );

    return resp.data;
  },
};
